import { EmailVerification } from 'assets/js/pages/account-settings/account-about/EmailVerification';
import { NonProfitVerification } from 'assets/js/pages/account-settings/account-about/NonProfitVerification';
import { PhoneVerification } from 'assets/js/pages/account-settings/account-about/PhoneVerification';
import { Permission, Permissions } from 'components/permissions';

const VerificationSettings = () => {
    return (
        <div className="flex flex-col gap-4">
            <EmailVerification />
            <PhoneVerification />
            <Permissions allowed={[Permission.Admin]}>
                <NonProfitVerification />
            </Permissions>
        </div>
    );
};

export { VerificationSettings };
